import AssigneeAddButton from './AssigneeAddButton'
import localize from '../../higherOrderComponents/localize'
import { connect } from 'react-redux'

export { mapUserToSuggestion } from './AssigneeAddButton'

const mapStateToProps = (state, ownProps) => ({
  projectMembers: state.projectMembers
})

export default connect(mapStateToProps)(localize(AssigneeAddButton))



// WEBPACK FOOTER //
// ./src/components/AssigneeAddButton/index.js